import { AboutContainer } from "./styles";

export function About() {
  return (
    <AboutContainer>
      <h1>Sobre</h1>
    </AboutContainer>
  );
}
